import util from '@/util'
import constants from '@/util/constants'

const loginMixin = {
  methods: {
    redirecionarVencimentoContratoPrincipal (idFaturaVencida) {
      if (!util.valorEhNulo(idFaturaVencida)) {
        this.$router.push({ name: constants.listaRotasFaturamento.rotaDetalhesFatura, params: { 'id': idFaturaVencida } })
        return
      }
      this.$router.push({ name: constants.listaRotasFaturamento.rotaListagemFaturas })
    },

    redirecionarVencimentosAdicionais (idFaturaVencida) {
      if (!util.valorEhNulo(idFaturaVencida)) {
        this.$router.push({ name: constants.listaRotasFaturamento.rotaDetalhesPedido, params: { 'id': idFaturaVencida } })
        return
      }
      this.$router.push({ name: constants.listaRotasFaturamento.rotaListagemPedidos })
    }
  }
}

export { loginMixin }
